module.exports = __webpack_public_path__ + "img/10_87.afd1c5f6.png";